"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withAvailableZoneByAttributes = exports.OBJ_STUB = void 0;
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var react_router_1 = require("react-router");
var reselect_1 = require("reselect");
var constants_1 = require("@gin-betting/constants");
var core_1 = __importDefault(require("@gin-betting/core"));
var selectors_1 = require("./selectors");
var selectSportTypeFromLocation = core_1.default.entities.selectors.selectSportTypeFromLocation, isMobile = core_1.default.constants.isMobile;
exports.OBJ_STUB = {};
var makeSelectProps = function (_a) {
    var location = _a.location, zoneLocation = _a.zoneLocation, _b = _a.sportType, sportType = _b === void 0 ? selectSportTypeFromLocation(exports.OBJ_STUB, { location: location }) : _b, index = _a.index;
    var platform = isMobile
        ? constants_1.BannerZonePlatform.MOBILE
        : constants_1.BannerZonePlatform.DESKTOP;
    var selectZoneId = selectors_1.makeSelectBannerIdByAttributes({
        index: index || 0,
        pageType: sportType,
        pageLocation: zoneLocation,
        platform: platform,
    });
    return reselect_1.createStructuredSelector({
        zoneId: selectZoneId,
    });
};
function withAvailableZoneByAttributes(Component, stub) {
    if (stub === void 0) { stub = null; }
    var BoundComponent = function (props) {
        var zoneLocation = props.zoneLocation, sportType = props.sportType, index = props.index;
        var location = react_router_1.useLocation();
        var selectProps = makeSelectProps({
            location: location,
            zoneLocation: zoneLocation,
            sportType: sportType,
            index: index,
        });
        var zoneId = react_redux_1.useSelector(function (state) {
            return selectProps(state, exports.OBJ_STUB);
        }).zoneId;
        if (!zoneId)
            return stub;
        return react_1.default.createElement(Component, __assign(__assign({}, props), { zoneId: zoneId }));
    };
    return BoundComponent;
}
exports.withAvailableZoneByAttributes = withAvailableZoneByAttributes;
//# sourceMappingURL=hocs.js.map